const getImageIdFromRootObject = (rootObjectPath: any): string | null => {
  return rootObjectPath?.id || null;
};

export default getImageIdFromRootObject;
